import { Select } from "antd";
import moment from "moment";
import React, { useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateManagePrescriptionSubmissionData } from "../../../../../actions/ManagePrescriptionAction";
import { AssetStore } from "../../../../../assets/AssetsStore";
import { BlueAdd } from "../../../../../assets/Logos/Icons";
import { followUpSchedule } from "../../../../../reducers/symptom.api";
import DatePickers from "../../../../ManagePrescriptionComponents/DatePicket/DatePicker";
import { PrescriprionContext } from "../../../PrintPrescription";
import DatePickerModal from "../../Modals/DatePickerModal/DatePickerModal";
import InformationModal from "../../Modals/InformationModal/InformationModal";
import styles from "./index.module.scss";

function FollowUp() {
  const dispatch = useDispatch();

  const [isDate, setIsDate] = useState(false);
  const [value, setValue] = useState();
  const [isMessageOPen, setMessageOpen] = useState(false);
  const { wholeData, handleWholeData } = useContext(PrescriprionContext);

  const submissionData = useSelector(
    (state) => state?.managePrescription?.submissionData
  );

  const handleChangeData = ({ key, value, isDate }) => {
    dispatch(
      updateManagePrescriptionSubmissionData({
        [key]: value,
      })
    );
  };

  const createSearchOptions = () => {
    let initialData = [
      "2 Days",
      "5 Days",
      "2 Weeks",
      "3 Weeks",
      "4 Weeks",
      "1 Month",
      "Select custom date",
    ];
    const result = [];
    initialData.map((e) => result.push({ label: e, value: e }));
    return result;
  };

  const handleOnChangeSelect = (e) => {
    console.log("handleOnChangeSelect",e)
    if (e === "Select custom date") {
      setIsDate(true);
      handleWholeData(
        "followUpDate",
       ""
      );
    } else {
      handleWholeData(
        "followUpDate",
        e
      );

      handleChangeData({
        key: "followup_date",
        value: { isDate: false, value: e },
      });
      setValue({ key: "followup_date", value: { isDate: false, value: e } });
    }
  };

  const handleOnChangeDate = (e) => {
    if (dateInPast(e)) {
      handleClearData();
    } else {
      handleWholeData(
        "followUpDate",
        moment(new Date(e)).format("DD-MMM-YYYY")
      );
      handleChangeData({
        key: "followup_date",
        value: { isDate: true, value: e },
      });
      setValue({ key: "followup_date", value: { isDate: true, value: e } });
    }
  };

  useEffect(() => {
    if (wholeData.followUpDate) {
      setValue({
        key: "followup_date",
        value: { isDate: true, value: wholeData.followUpDate },
      });
    }
  }, []);

  const handleSubmit = () => {
    followUpSchedule(
      moment(new Date(value.value.value)).format("DD-MMM-YYYY"),
      () => toggleMessageModal(true)
    );
  };

  const toggleMessageModal = (param) => setMessageOpen(param ? param : false);

  useEffect(() => {
    if (submissionData?.followup_date?.value) {
      setIsDate(submissionData?.followup_date?.isDate);
    }
  }, [submissionData?.followup_date?.isDate]);

  const handleClearData = () => {
    handleWholeData("followUpDate", "");
    setIsDate(false);
    handleChangeData({
      key: "followup_date",
      value: { isDate: false, value: undefined },
    });
    setValue({ key: "followup_date", value: { isDate: false, value: undefined } });
  };

  const dateInPast = (date) => {
    const currentDate = new Date();
    if (new Date(date)?.setHours(0, 0, 0, 0) < currentDate?.setHours(0, 0, 0, 0)) {
      return true;
    }

    return false;
  };

  console.log("value",submissionData)

  return (
    <div className={styles.followup_container}>
      {/* <div className={styles.caption}>Date</div> */}
      <div className={styles.form_row}>
        <div className={styles.inputAndClearRow}>
          <div onClick={handleClearData} className={styles.clear_btn}>
            <div className={styles.title}>Date</div>
            {submissionData?.followup_date?.value ? "Reset" : " "}
          </div>
          {
                    isDate ?
                        <DatePickers
                            value={submissionData?.followup_date?.isDate && submissionData?.followup_date?.value && moment(submissionData?.followup_date.value)} onChange={(e, d) => {
                              handleOnChangeDate(e);
                            }} />
                        :
                        <div className={styles.searchBox}>
                            <Select
                                // suffixIcon={<img src={AssetStore.managePrescription.calander} alt="" />}
                                onSelect={handleOnChangeSelect}
                                getPopupContainer={trigger => trigger.parentNode}
                                placeholder={"Select a date"}
                                optionFilterProp="children"
                                options={createSearchOptions()}
                                //defaultValue={"Select a date"}
                                value={!submissionData?.followup_date?.isDate && submissionData?.followup_date?.value}
                            />
                        </div>
                }
          {/* {
                        isDate ? */}
          {/* <DatePickers
            disablePast
            value={
              submissionData?.followup_date?.isDate &&
              submissionData?.followup_date?.value &&
              moment(submissionData?.followup_date.value)
            }
            onChange={(e, d) => {
              handleOnChangeDate(e);
            }}
          /> */}
          {/* : */}
          {/* <div className={styles.searchBox}>
                                <Select
                                    value={!submissionData?.followup_date?.isDate && submissionData?.followup_date?.value}
                                    // suffixIcon={<img src={AssetStore.managePrescription.calander} alt="" />}
                                    onChange={handleOnChangeSelect}
                                    getPopupContainer={trigger => trigger.parentNode}
                                    placeholder="Select a date"
                                    optionFilterProp="children"
                                    options={createSearchOptions()}
                                />
                            </div> */}
          {/* } */}
        </div>

        {/* <button
          disabled={submissionData?.followup_date?.value ? false : true}
          onClick={handleSubmit}
          className={styles.schedule_btn}
        >
          Schedule
        </button> */}
      </div>

      <InformationModal
        onSubmit={(e) => {
          toggleMessageModal(false);
        }}
        title={"Successfully scheduled."}
        showModal={isMessageOPen}
        hidemodal={() => {
          toggleMessageModal(false);
        }}
      />
    </div>
  );
}

export default FollowUp;
